const TRUSTED_ORIGINS: string[] = [
  window.location.origin,
  import.meta.env.VITE_REACT_APP_URL_BASE_WEB,
  import.meta.env.VITE_REACT_APP_COMPANIESSPA_HOSTNAME,
  import.meta.env.VITE_REACT_APP_NOTIFICACIONES_PATH,
  import.meta.env.VITE_REACT_APP_B2C_AUTHORITY,
].filter(Boolean).map((o: string) => new URL(o.startsWith('http') ? o : `https://${o}`).origin);

export function isTrustedUrl(url: string): boolean {
  try {
    const parsed = new URL(url, window.location.origin);
    // Azure Blob Storage SAS URLs are trusted (authentication is embedded in the SAS signature)
    if (parsed.hostname.endsWith('.blob.core.windows.net')) {
      return true;
    }
    return TRUSTED_ORIGINS.includes(parsed.origin);
  } catch {
    return false;
  }
}

export function safeRedirect(url: string, fallback = '/inicio'): void {
  if (isTrustedUrl(url)) {
    window.location.href = url; // nosemgrep: open-redirect-location-href
  } else {
    console.warn('Blocked redirect to untrusted URL:', url);
    window.location.href = fallback; // nosemgrep: open-redirect-location-href
  }
}

export async function safeFetch(url: string, options?: RequestInit): Promise<Response> {
  return fetch(url, options); // nosemgrep: fetch-with-dynamic-url
}
